import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "9",
  height: "9",
  viewBox: "0 0 9 9"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    id: "close",
    transform: "translate(0.75 0.75)"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      id: "Path",
      d: "M7.5,0,0,7.5",
      fill: "none",
      stroke: "#000",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.5"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      id: "Path-2",
      "data-name": "Path",
      d: "M0,0,7.5,7.5",
      fill: "none",
      stroke: "#000",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.5"
    })
  ])
], -1)
const _hoisted_2 = { class: "drawer-content" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h6", null, "Configurator", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "See our dashboard options.", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_6 = { class: "sidebar-color" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h6", null, "Sidebar Color", -1)
const _hoisted_8 = { class: "" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h6", null, "Sidenav Type", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "Choose between 2 different sidenav types.", -1)
const _hoisted_11 = { class: "navbar-fixed" }
const _hoisted_12 = { class: "navbar-fixed" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h6", null, [
  /*#__PURE__*/_createTextVNode("Dark theme "),
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-moon" })
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-sun" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-moon" }, null, -1)
const _hoisted_16 = { class: "download" }
const _hoisted_17 = { class: "github-stars" }
const _hoisted_18 = { class: "sharing" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h6", null, "Thank you for sharing!", -1)
const _hoisted_20 = { class: "share-links" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("svg", {
  width: "15px",
  height: "15px",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z" })
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("svg", {
  width: "15px",
  height: "15px",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M503.691 189.836L327.687 37.851C312.281 24.546 288 35.347 288 56.015v80.053C127.371 137.907 0 170.1 0 322.326c0 61.441 39.581 122.309 83.333 154.132 13.653 9.931 33.111-2.533 28.077-18.631C66.066 312.814 132.917 274.316 288 272.085V360c0 20.7 24.3 31.453 39.687 18.164l176.004-152c11.071-9.562 11.086-26.753 0-36.328z" })
], -1)

import { reactive, ref, onMounted } from 'vue'
import cookiesConFig from "@/utils/CookiesConfig";
import {
  DARK_TYPE,
  SIDEBAR_COLOR,
  SIDEBAR_THEME,
  NAVBAR_FIXED,
  NAVBAR_DARK_MODEL,
  SIDEBAR_COLOR_MODEL,
  SIDEBAR_THEME_MODEL,
  NAVBAR_FIXED_MODEL
  
} from "@/const/ConstCookies";
interface props {
    showSettingsDrawer: boolean,
    sidebarColor: string,
	sidebarTheme: string,
	navbarFixed: boolean,
	rtl: boolean,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardSettingsDrawer',
  props: {
    showSettingsDrawer: { type: Boolean },
    sidebarColor: { default: 'primary' },
    sidebarTheme: { default: 'light' },
    navbarFixed: { type: Boolean, default: false },
    rtl: { type: Boolean }
  },
  emits: ["darkModel","toggleNavbarPosition", "updateSidebarTheme", "updateSidebarColor", "toggleSettingsDrawer"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit

const propsData = __props;

const sidebarColorModel = ref('')
const sidebarThemeModel = ref('')
const navbarFixedModel = ref(false)
const navbarDarkModel = ref(false)

onMounted(()=> {
	modelConfig()
})
const toggleDarkModel = () => {
	cookiesConFig.setCokies(NAVBAR_DARK_MODEL, navbarDarkModel.value)
	if(navbarDarkModel.value) {
		emits('darkModel', 'dark-mode')
	} else {
		emits('darkModel', '')
	}
}
const toggleNavbar = (val:any) => {
	cookiesConFig.setCokies(NAVBAR_FIXED_MODEL, val)
	emits('toggleNavbarPosition', val)
}

const updateSidebarTheme = (val:any) => {
	emits('updateSidebarTheme', val)
}

const updateSidebarColor = (val:any) => {
	emits('updateSidebarColor', val)
}

const toggleSettingsDrawer = (val:any) => {
	emits('toggleSettingsDrawer', val)
}
const modelConfig = () => {
	sidebarColorModel.value = cookiesConFig.getCokies(SIDEBAR_COLOR);
	sidebarThemeModel.value = cookiesConFig.getCokies(SIDEBAR_THEME);
	navbarFixedModel.value = cookiesConFig.getCokiesBoolean(NAVBAR_FIXED_MODEL);
    navbarDarkModel.value = cookiesConFig.getCokiesBoolean(NAVBAR_DARK_MODEL);
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_flex = _resolveComponent("a-flex")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_gh_btns_star = _resolveComponent("gh-btns-star")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createBlock(_component_a_drawer, {
    class: _normalizeClass(["settings-drawer", [ _ctx.rtl ? 'settings-drawer-rtl' : '' ]]),
    placement: _ctx.rtl ? 'left' : 'right',
    closable: false,
    visible: _ctx.showSettingsDrawer,
    width: "360",
    onClose: _cache[9] || (_cache[9] = ($event: any) => (toggleSettingsDrawer(false)))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_button, {
        type: "link",
        class: "btn-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleSettingsDrawer(false)))
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_a_radio_group, {
            modelValue: sidebarColorModel.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((sidebarColorModel).value = $event)),
            onChange: _cache[2] || (_cache[2] = ($event: any) => (updateSidebarColor($event.target.value))),
            defaultValue: "primary"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_radio_button, {
                value: "primary",
                class: "bg-primary"
              }),
              _createVNode(_component_a_radio_button, {
                value: "secondary",
                class: "bg-secondary"
              }),
              _createVNode(_component_a_radio_button, {
                value: "success",
                class: "bg-success"
              }),
              _createVNode(_component_a_radio_button, {
                value: "danger",
                class: "bg-danger"
              }),
              _createVNode(_component_a_radio_button, {
                value: "warning",
                class: "bg-warning"
              }),
              _createVNode(_component_a_radio_button, {
                value: "black",
                class: "bg-dark"
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _hoisted_10,
          _createVNode(_component_a_flex, {
            wrap: "wrap",
            gap: "small"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                style: {"background":"transparent","text-transform":"uppercase"},
                onClick: _cache[3] || (_cache[3] = ($event: any) => (updateSidebarTheme('light')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('config.transparent')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_a_button, {
                style: {"background":"#fff","text-transform":"uppercase"},
                onClick: _cache[4] || (_cache[4] = ($event: any) => (updateSidebarTheme('white')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('config.white')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_a_button, {
                style: {"background":"#001529","color":"#fff","text-transform":"uppercase"},
                onClick: _cache[5] || (_cache[5] = ($event: any) => (updateSidebarTheme('dark')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('config.dark')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("h6", null, _toDisplayString(_ctx.$t('message.000001')), 1),
          _createVNode(_component_a_switch, {
            "default-checked": "",
            checked: navbarFixedModel.value,
            "onUpdate:checked": _cache[6] || (_cache[6] = ($event: any) => ((navbarFixedModel).value = $event)),
            onChange: _cache[7] || (_cache[7] = ($event: any) => (toggleNavbar(navbarFixedModel.value)))
          }, null, 8, ["checked"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createVNode(_component_a_switch, {
            checked: navbarDarkModel.value,
            "onUpdate:checked": _cache[8] || (_cache[8] = ($event: any) => ((navbarDarkModel).value = $event)),
            onChange: toggleDarkModel
          }, {
            checkedChildren: _withCtx(() => [
              _hoisted_14
            ]),
            unCheckedChildren: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          }, 8, ["checked"])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_a_button, {
            type: "dark",
            href: "https://www.creative-tim.com/product/muse-vue-ant-design-dashboard",
            block: "",
            target: "_blank"
          }, {
            default: _withCtx(() => [
              _createTextVNode("FREE DOWNLOAD")
            ]),
            _: 1
          }),
          _createVNode(_component_a_button, {
            type: "primary",
            href: "https://www.creative-tim.com/product/muse-vue-ant-design-dashboard-pro",
            block: "",
            target: "_blank"
          }, {
            default: _withCtx(() => [
              _createTextVNode("UPGRADE TO PRO")
            ]),
            _: 1
          }),
          _createVNode(_component_a_button, {
            type: "secondary",
            href: "https://demos.creative-tim.com/muse-vue-ant-design-dashboard/documentation",
            block: "",
            target: "_blank"
          }, {
            default: _withCtx(() => [
              _createTextVNode("VIEW DOCUMENTATION")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_gh_btns_star, {
            slug: "creativetimofficial/muse-vue-ant-design-dashboard",
            "show-count": ""
          })
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_a_button, {
              type: "dark",
              target: "_blank",
              href: "https://twitter.com/intent/tweet?url=https://www.creative-tim.com/product/muse-vue-ant-design-dashboard&text=Check%20Muse%20Vue%20Ant%20Design%20made%20by%20@CreativeTim%20#webdesign%20#dashboard%20#antdesign%20#vue%20https://www.creative-tim.com/product/muse-vue-ant-design-dashboard",
              size: "small"
            }, {
              default: _withCtx(() => [
                _hoisted_21,
                _createTextVNode(" TWEET ")
              ]),
              _: 1
            }),
            _createVNode(_component_a_button, {
              type: "dark",
              target: "_blank",
              href: "https://www.facebook.com/sharer/sharer.php?u=https://www.creative-tim.com/product/muse-vue-ant-design-dashboard",
              size: "small"
            }, {
              default: _withCtx(() => [
                _hoisted_22,
                _createTextVNode(" SHARE ")
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["class", "placement", "visible"]))
}
}

})